import React, { useState } from 'react';
import './Header.css';
import { useAuth } from '../context/AuthContext';

const Header = (props) => {

    const authCtx = useAuth();
    const [toggleIcon, setToogleIcon] = useState('open');

    const handleLogout = ()=>{
        authCtx.onLogOut();
    }

    const toogleMenu = ()=>{
        setToogleIcon((prevstate)=>{
            if (prevstate === 'open') {
                return 'closed'; // return the new state
            } else {
                return 'open'; // return the new state
            }
        });
        props.toggleSidebar();
    }

    return (
        <header className="header">
            <div className='d-flex justify-content-between align-items-center'>
                <div className='menu-toogle-button'>
                    <img src="/assets/logo/company_logo_white.svg" alt="CompanyLogo" width={'100px'}></img>

                    { !props.isMobileView &&
                        ((toggleIcon === 'open') ? (
                            <button onClick={toogleMenu} className="toggle-button">
                                <i className="bi bi-chevron-double-left"></i>
                            </button>
                        ) : (
                            <button onClick={toogleMenu} className="toggle-button">
                                <i className="bi bi-chevron-double-right"></i>
                            </button>
                        ))
                    }

                </div>

                { props.isMobileView ? (
                    <button onClick={toogleMenu} className="toggle-button">
                        <i className="bi bi-list"></i>
                    </button>
                    ) :
                    <div style={{cursor:'pointer'}} onClick={handleLogout} data-toggle="tooltip" data-placement="bottom" title="Click here to logout">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" className="bi bi-power" viewBox="0 0 16 16">
                            <path d="M7.5 1v7h1V1z" />
                            <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
                        </svg>
                    </div>
                }
            </div>
        </header>
    );
};

export default Header;